// extracted by mini-css-extract-plugin
export var arrows = "_68-6";
export var decrementer = "_68-a";
export var disabled = "_68-4";
export var error = "_68-1";
export var hiddenText = "_68-b";
export var incrementer = "_68-9";
export var input = "_68-8";
export var inputWrapper = "_68-0";
export var leadingIcon = "_68-c";
export var readonly = "_68-3";
export var regular = "_68-7";
export var small = "_68-5";
export var warning = "_68-2";